import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'

type Props = {
  title: string
  confirmLabel: string
  onCancel: () => void
  onConfirm: () => void
  tone?: 'danger' | 'warning'
  confirmVariant?: 'danger' | 'warning' | 'primary'
  irreversibleMessage?: string
  children: React.ReactNode
}

/** Shared confirm modal for wheel management actions (delete, activate, etc.). */
export function WheelManagementActionsConfirmModal({
  title,
  confirmLabel,
  onCancel,
  onConfirm,
  tone = 'danger',
  confirmVariant,
  irreversibleMessage = 'This action cannot be undone.',
  children,
}: Props) {
  const isWarning = tone === 'warning'
  const confirmClassName =
    confirmVariant === 'primary'
      ? 'gw-wm__btn-primary'
      : confirmVariant === 'warning' || isWarning
        ? 'gw-wm__btn-warning'
        : 'gw-wm__btn-danger'

  return (
    <div className="gw-wm__modal-backdrop" role="dialog" aria-modal="true">
      <div className="gw-wm__modal">
        <WheelManagementActionsConfirmModalHead
          isWarning={isWarning}
          title={title}
        />
        <div className="gw-wm__modal-body">
          {children}
          {irreversibleMessage ? (
            <p
              className={`mt-2 fw-semibold small mb-4 ${
                isWarning ? 'gw-wm__modal-note--warning' : 'text-danger'
              }`}
            >
              {irreversibleMessage}
            </p>
          ) : null}
        </div>
        <div className="gw-wm__modal-actions">
          <button
            type="button"
            className="gw-wm__btn-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className={confirmClassName}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

function WheelManagementActionsConfirmModalHead({
  isWarning,
  title,
}: {
  isWarning: boolean
  title: string
}) {
  return (
    <div className="gw-wm__modal-head">
      <div
        className={`gw-wm__modal-icon-wrap ${
          isWarning ? 'gw-wm__modal-icon-wrap--warning' : ''
        }`}
      >
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </div>
      <h3 className="gw-wm__panel-title gw-wm__modal-title">{title}</h3>
    </div>
  )
}
